import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=0c7d964e&scoped=true&"
import script from "./BookingStatus.vue?vue&type=script&lang=js&"
export * from "./BookingStatus.vue?vue&type=script&lang=js&"
import style0 from "./BookingStatus.vue?vue&type=style&index=0&id=0c7d964e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7d964e",
  null
  
)

export default component.exports